import clsx from 'clsx'
import { FC } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { UserModel } from '../../../../app/modules/auth/models/UserModel'
import { RootState } from '../../../../setup'
import { HeaderUserMenu } from '../../../partials'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'
/*interface userJRR {
  email?: string,
  username?: string,
  pic?: string
}*/

const Topbar: FC = () => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='topbar d-flex align-items-stretch flex-shrink-0'>
        {/* Search */}
        {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search />
      </div> */}
        {/* Activities */}
        {/*<div className={clsx('d-flex align-items-center ', toolbarButtonMarginClass)}>*/}
        {/*  */}{/* begin::Drawer toggle */}
        {/*  <div*/}
        {/*    className={clsx(*/}
        {/*      'btn btn-icon btn-active-light-primary position-relative',*/}
        {/*      toolbarButtonHeightClass*/}
        {/*    )}*/}
        {/*    id='kt_activities_toggle'*/}
        {/*  >*/}
        {/*    <KTSVG*/}
        {/*      path='/media/icons/duotune/general/gen032.svg'*/}
        {/*      className={toolbarButtonIconSizeClass}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  */}{/* end::Drawer toggle */}
        {/*</div>*/}
        {/* Quick links */}
        {/*<div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>*/}
        {/*  */}{/* begin::Menu wrapper */}
        {/*  <div*/}
        {/*    className={clsx(*/}
        {/*      'btn btn-icon btn-active-light-primary position-relative',*/}
        {/*      toolbarButtonHeightClass*/}
        {/*    )}*/}
        {/*    data-kt-menu-trigger='click'*/}
        {/*    data-kt-menu-attach='parent'*/}
        {/*    data-kt-menu-placement='bottom-end'*/}
        {/*    data-kt-menu-flip='bottom'*/}
        {/*  >*/}
        {/*    <KTSVG*/}
        {/*      path='/media/icons/duotune/general/gen025.svg'*/}
        {/*      className={toolbarButtonIconSizeClass}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <QuickLinks />*/}
        {/*  */}{/* end::Menu wrapper */}
        {/*</div>*/}

        {/* NOTIFICATIONS */}
        {/*<div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>*/}
        {/*  */}{/* begin::Menu- wrapper */}
        {/*  <div*/}
        {/*    className={clsx(*/}
        {/*      'btn btn-icon btn-active-light-primary position-relative',*/}
        {/*      toolbarButtonHeightClass*/}
        {/*    )}*/}
        {/*    data-kt-menu-trigger='click'*/}
        {/*    data-kt-menu-attach='parent'*/}
        {/*    data-kt-menu-placement='bottom-end'*/}
        {/*    data-kt-menu-flip='bottom'*/}
        {/*  >*/}
        {/*    <KTSVG*/}
        {/*      path='/media/icons/duotune/general/gen022.svg'*/}
        {/*      className={toolbarButtonIconSizeClass}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <HeaderNotificationsMenu />*/}
        {/*  */}{/* end::Menu wrapper */}
        {/*</div>*/}

        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center p-2', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'>
            <div className="d-inline-block text-left mr-3 font-size">
              <span className="d-block"><b>{user.username}</b></span>
              <span className="d-block">{user.email}</span>
            </div>
            <img
              className='rounded logo-space'
              src={user.pic}
              alt='metronic'
            />
            { }
          </div>
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </div>
  )
}

export { Topbar }
